module.exports = __webpack_public_path__ + "img/icon_07.80ed2c88.png";